import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'

import { isEmptyOrNull } from '@/utils'
import useLocalStorage from '@/hooks/use-localstorage'
import useSessionComplete from '@/hooks/use-session-complete'

const allowedPaths = [
  '/rental-listings',
  '/company',
  '/favourites',
  '/offcampushousing'
]
const allowedHosts = ['offcampus-housing.com']

const useCheckRecentMessages = () => {
  const dispatch = useDispatch()
  const router = useRouter()
  const isLoggedIn = useSessionComplete()
  const [recentMessages, setRecentMessages] = useLocalStorage(
    'recentMessages',
    {}
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const isMatchingHostname = allowedHosts.some(host =>
      window.location.hostname.includes(host)
    )
    const isMatchingPage = allowedPaths.some(path =>
      router.pathname.includes(path)
    )
    if (!isMatchingHostname && !isMatchingPage) return

    // Update chat.recent_timeline_rooms redux state:
    if (isLoggedIn) {
      // If user is logged in update from BE and clear localStorage
      dispatch.chat.checkRecentMessages()
      if (!isEmptyOrNull(recentMessages)) {
        setRecentMessages({})
      }
    } else {
      // If user is not logged in we update from localStorage
      const updatedMessages = JSON.parse(
        localStorage.getItem('recentMessages') || '{}'
      )
      if (!isEmptyOrNull(updatedMessages)) {
        dispatch.chat.saveRecent(updatedMessages)
      }
    }
  }, [
    dispatch.chat,
    isLoggedIn,
    recentMessages,
    setRecentMessages,
    router.pathname
  ])
}

export default useCheckRecentMessages
